import { render, staticRenderFns } from "./ClipIcon.vue?vue&type=template&id=1b2df754&"
import script from "./ClipIcon.vue?vue&type=script&lang=js&"
export * from "./ClipIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports